export default "__VITE_ASSET__8e28e417__"